import { render, staticRenderFns } from "./MenuHeader.vue?vue&type=template&id=6f42185f&scoped=true&"
import script from "./MenuHeader.vue?vue&type=script&lang=js&"
export * from "./MenuHeader.vue?vue&type=script&lang=js&"
import style0 from "./MenuHeader.vue?vue&type=style&index=0&id=6f42185f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f42185f",
  null
  
)

export default component.exports